import { SpeakingMonitoringResult } from 'api';

export const getSpeakingMonitoringResultName = (resultType: SpeakingMonitoringResult): string => {
  const resultTypeNames: Record<SpeakingMonitoringResult, string> = {
    [SpeakingMonitoringResult.NotApplicable]: 'Not Applicable',
    [SpeakingMonitoringResult.Standard]: 'Standard',
    [SpeakingMonitoringResult.NonStandardA]: 'Non-Standard A',
    [SpeakingMonitoringResult.NonStandardB]: 'Non-Standard B',
    [SpeakingMonitoringResult.NonStandardC]: 'Non-Standard C',
  };

  return resultTypeNames[resultType] ?? '-';
};
